import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { GenericProductData } from '@legacy/common-ui-models';
import type { InnogyComponentRendering } from '@core/jss-models';
import { TextField, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { TrackLinkDirective } from '@analytics/events';

import { GenericRatingComponent } from '../generic-rating/generic-rating.component';
import { GenericOfferInfoComponent } from '../generic-offer-info/generic-offer-info.component';
import { GenericUspsComponent } from '../generic-usps/generic-usps.component';

@Component({
  selector: 'wl-generic-offer',
  templateUrl: './generic-offer.component.html',
  styleUrls: [
    './generic-offer.component.essent.scss',
    './generic-offer.component.ed.scss',
  ],
  host: {
    ngSkipHydration: 'true',
  },
  standalone: true,
  imports: [
    AutomationIdDirective,
    CSCaptureDirective,
    NgClass,
    GenericRatingComponent,
    GenericOfferInfoComponent,
    GenericUspsComponent,
    RichTextWrapperComponent,
    JssModule,
    TrackLinkDirective,
  ],
})
export class GenericOfferComponent<TProduct extends GenericProductData> {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | any;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) product!: TProduct;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonTextField?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mode: 'display' | 'select' = 'display';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selected = false;

  @Output() clicked = new EventEmitter<TProduct>();
  @Output() secondaryClicked = new EventEmitter<TProduct>();

  get isSelectable() {
    return this.mode === 'select';
  }

  get isHighlighted() {
    return !!this.product.content.highlight;
  }

  get buttonLinkUrl() {
    return this.product.content.submitButtonAction === 'navigate'
      ? this.product.content.submitButtonLink?.href
      : undefined;
  }

  get secondaryButtonLinkUrl() {
    return this.product.content.secondaryButtonAction === 'navigate'
      ? this.product.content.secondaryButtonLink?.href
      : undefined;
  }

  onClicked() {
    this.clicked.emit(this.product);
  }

  onSecondaryClicked() {
    this.secondaryClicked.emit(this.product);
  }
}
